import React from "react";

interface InsuredAgeIconProps {
  width?: string;
  height?: string;
  fillColor?: string;
}

const InsuredAgeIcon: React.FC<InsuredAgeIconProps> = ({
  width = "24px",
  height = "24px",
  fillColor = "#314158",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 15 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.0809 5.00426C9.30255 5.00426 7.86383 6.44298 7.86383 8.22128C7.86383 9.99958 9.30255 11.4383 11.0809 11.4383C12.8591 11.4383 14.2979 9.99958 14.2979 8.22128C14.2979 6.44298 12.8591 5.00426 11.0809 5.00426ZM12.5106 8.36202C12.5106 8.48043 12.4123 8.57872 12.2939 8.57872H10.9401C10.8217 8.57872 10.7234 8.48043 10.7234 8.36202V6.65075C10.7234 6.53234 10.8217 6.43404 10.9401 6.43404H11.2216C11.34 6.43404 11.4383 6.53234 11.4383 6.65075V7.86383H12.2939C12.4123 7.86383 12.5106 7.96213 12.5106 8.08053V8.36202ZM7.14894 8.22128C7.14894 7.60021 7.29862 7.01266 7.55553 6.48989C7.37681 6.45638 7.19362 6.43404 7.00596 6.43404H6.63287C6.13692 6.66192 5.58511 6.79149 5.00426 6.79149C4.4234 6.79149 3.87383 6.66192 3.37564 6.43404H3.00255C1.34489 6.43404 0 7.77894 0 9.4366V10.366C0 10.958 0.480319 11.4383 1.07234 11.4383H8.8267C7.81468 10.7256 7.14894 9.55053 7.14894 8.22128ZM5.00426 5.71915C6.58372 5.71915 7.86383 4.43904 7.86383 2.85957C7.86383 1.28011 6.58372 0 5.00426 0C3.42479 0 2.14468 1.28011 2.14468 2.85957C2.14468 4.43904 3.42479 5.71915 5.00426 5.71915Z"
      style={{ fill: fillColor }}
    />
  </svg>
);

export default InsuredAgeIcon;
